import { render, staticRenderFns } from "./RestrictionsTable.vue?vue&type=template&id=65126215&"
import script from "./RestrictionsTable.vue?vue&type=script&lang=js&"
export * from "./RestrictionsTable.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports